import {
  IEltDocFormData,
  IELTFormData,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'

export const stepsContents: Record<number, (keyof IELTFormData)[]> = {
  1: [
    'MeetingMainInfo',
    'HpAttendees',
    'AccountAttendees',
    'MeetingAgenda',
    'MeetingSummary',
    'LastEngagement',
    'CompanyAtGlance',
  ],
  2: ['MeetingPurpose', 'LongTermPriorities', 'ShortTermPriorities', 'SupportingPriorities'],
  3: [
    'Revenue',
    'CompetitiveLandscape',
    'SoldProductData',
    'Issues',
    'KeyOpportunities',
    'GoodNewsDesc',
    'NeedSupport',
    'FinancialPerformance',
    'HPSob',
  ],
  4: ['SupportTopics', 'MeetingObjective'],
  5: ['Revenue', 'BalanceOfTrade', 'BalanceOfTradeSummary'],
}

export const stepsDocContents: Record<number, (keyof IEltDocFormData)[]> = {
  1: [
    'Company',
    'CompetitiveLandscape',
    'MeetingObjectives',
    'BalanceOfTrade',
    'CustomerRevenue',
    'LastEngagement',
    'HpExecutiveKeyPoints',
    'AdditionalNotes',
    'TopIssues',
    'TopOpportunities',
  ],
  2: ['Company', 'CompanyAtGlanceInputs', 'CompanyPerformance'],
  3: ['IsBusinessPerformanceTabEnabled', 'BusinessPerformanceData'],
}
